import { Button, Text, TextInput, Select, Textarea } from "@mantine/core";
import React from "react";
import { useFormRender } from "../hooks/useFormRender";
import { getAddFormSchema } from "../pages/operation/user";
import { useTranslation } from "react-i18next";

const UserEditButton = ({ mainForm }) => {
  const { t } = useTranslation();

  let formSchema = { ...getAddFormSchema(t) };
  formSchema.title = "Edit User Details";

  const onSubmit = async ({ values, formMode }) => {
    // mainForm.setValues(values);
    await mainForm.saveValues(values);
    await mainForm.reload();
    formAction.close();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    const id = mainForm?.values._id;
    if (!id) return;
    formAction.open({ mode: "edit", id, data: mainForm.values });
  };

  return (
    <>
      {/* {JSON.stringify(mainForm.values.termination)} */}
      <Button fullWidth onClick={handleActionClick}>
        {t("Edit Details")}
      </Button>
      {renderForm()}
    </>
  );
};

export default UserEditButton;
